<template>
  <div
    v-if="metaData"
    class="text-field"
    :class="{ [metaData.addendumClassName]: metaData.isRevised }"
  >
    <label
      v-if="(!readonly || viewModeWithValue) && !hideLabel"
      :class="{ 'required-flag': required && !readonly }"
    >
      <template v-if="metaData.fieldName">
        {{ $t(`tender.general.${metaData.fieldName}`) }}:
      </template>
    </label>
    <pre><p v-if="viewModeWithValue">{{ metaData.value }}</p></pre>
    <div
      v-if="!readonly"
      class="row text-input"
    >
      <textarea
        :class="{ 'small-2 medium-2 large-2 columns': metaData.text }"
        :name="metaData.fieldName"
        :value="metaData.value"
        @change="updateFieldValue"
        @input="updateFieldValue"
        class="autosize"
        v-autosize
        v-hkldinput
        :required="required"
      />
      <pre><p
class="additional-text"
              v-if="metaData.text"
      >{{ metaData.text }}</p></pre>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import mutationTypes from '@/store/mutation-types'

export default {
  name: 'tenderTextField',

  props: {
    metaData: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ...mapMutations('tenders', {
      updateTenderField: mutationTypes.TENDER_UPDATE_FIELD,
    }),
    updateFieldValue (event) {
      this.updateTenderField({
        sectionName: this.metaData.sectionName,
        fieldName: this.metaData.fieldName,
        newValue: event.target.value.trim(),
      })
    },
  },

  computed: {
    viewModeWithValue () {
      return this.readonly && ((this.metaData || {}).value || this.required)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/view';
@import '~styles/tender/addendum';
@import '~styles/textField';

pre{
  overflow-x: hidden;
  p {
    word-break: keep-all;
    text-align: justify;
  }
}

</style>
